<template>
  <li>
    <component
      :is="getElement()"
      v-bind="getElementAttributes()"
      v-on="getElementListeners()"
    >
      <span
        v-if="icon"
        class="icon"
      >
        <i :class="icon" />
      </span>
      {{ $t(name) }}
    </component>
    <ul v-show="!collapsed">
      <menu-item
        v-for="child in children"
        :key="child.name"
        v-bind="child"
      />
    </ul>
  </li>
</template>

<script>
  export default {
    name: 'MenuItem',
    props: {
      name: {
        type: String,
        required: true
      },
      icon: {
        type: String,
        default: null
      },
      path: {
        type: [String, Object],
        default: ''
      },
      children: {
        type: Array,
        default: null
      }
    },
    data () {
      return {
        collapsed: true
      }
    },
    methods: {
      handleClick (event) {
        event.preventDefault()
        this.collapsed = !this.collapsed
      },
      getElement () {
        return this.children ? 'a' : 'router-link'
      },
      getElementAttributes () {
        // href has to be present for key binding to work
        return this.children ? { 'tabindex': 0, 'href': '#' } : { 'to': this.path, ...this.$attrs }
      },
      getElementListeners () {
        return this.children ? { 'click': this.handleClick } : {}
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/styles";

    a {
      color: nth(map_get($colors, 'brand'), 2);
      outline-color: nth(map_get($colors, 'brand'), 2);

      &.is-active {
        color: nth(map_get($colors, 'brand'), 1);
        background: nth(map_get($colors, 'brand'), 2);
      }

      &:hover:not(.is-active) {
        color: nth(map_get($colors, 'brand'), 2);
        background: transparentize(nth(map_get($colors, 'brand'), 2), 0.85);
      }
    }
</style>
